import { IReduxStore } from "Redux/Store/IReduxStore";

export const getLastSpotId = (state: IReduxStore) => state.spot.lastInteractiveId;